import { ElevatedCircle, type ElevatedCircleProps } from "lola-framework-ui-test";
import type { ReactNode } from "react";

export interface ElevatedCircleWrapperProps {
  circleContainerBg?: string;
  iconContainerBg?: string;
  children?: ReactNode;
  isRotated?: boolean;
  /**
   * Disc diameter forwarded to lola `ElevatedCircle`. Lola pins its default
   * (128px) as an inline `min-width`/`min-height`, so a stylesheet alone
   * cannot shrink the disc below that; pass the target size here instead.
   */
  size?: number | string;
}

export const ElevatedCircleWrapper: React.FC<ElevatedCircleWrapperProps> = ({
  circleContainerBg = "#fff",
  iconContainerBg = "#fff",
  isRotated = false,
  size,
  children,
}) => (
  <ElevatedCircle {...({ size } as unknown as ElevatedCircleProps)}>
    <section
      className="circle-container"
      style={{ background: circleContainerBg }}
    >
      <section
        className={`icon-container ${isRotated ? "rotate" : ""}`}
        style={{
          background: iconContainerBg,
        }}
      >
        {children}
      </section>
    </section>
  </ElevatedCircle>
);
